export const STATUS_OPTIONS = [
  { value: 'new', label: 'New', badge: 'bg-blue-100 text-blue-700' },
  { value: 'in_progress', label: 'In Progress', badge: 'bg-amber-100 text-amber-700' },
  { value: 'waiting', label: 'Waiting', badge: 'bg-purple-100 text-purple-700' },
  { value: 'closed', label: 'Closed', badge: 'bg-slate-200 text-slate-600' },
  { value: 'won', label: 'Won', badge: 'bg-emerald-100 text-emerald-700' },
  { value: 'lost', label: 'Lost', badge: 'bg-red-100 text-red-700' },
];

export const statusMeta = (value) => STATUS_OPTIONS.find((s) => s.value === value) || STATUS_OPTIONS[0];
